import { useEffect, useRef, useCallback } from "react";

export const useUserActivity = (onActivity, options = {}) => {
  const { throttleMs = 1000, enabled = true } = options;

  const lastActivityRef = useRef(Date.now());

  const handleActivity = useCallback(() => {
    if (!enabled) return;

    const now = Date.now();
    // Throttle: only call onActivity if enough time has passed
    if (now - lastActivityRef.current >= throttleMs) {
      lastActivityRef.current = now;
      onActivity();
    }
  }, [onActivity, throttleMs, enabled]);

  useEffect(() => {
    if (!enabled) return;

    const events = ["mousedown", "mousemove", "keypress", "scroll", "touchstart", "click"];

    // Add event listeners
    events.forEach((event) => {
      document.addEventListener(event, handleActivity, true);
    });

    // Cleanup
    return () => {
      events.forEach((event) => {
        document.removeEventListener(event, handleActivity, true);
      });
    };
  }, [handleActivity, enabled]);
};
